import React, { Component } from "react"
import { connect } from 'react-redux'
import { Input } from "../core";
import { saveTransactionAction } from '../../redux/actions/MainAction'
import {
    UploadPanel,
    UploadList
}
    from ".."

import { msg } from '../Notifications/MsgBox';
import { UploadPanelCommittee } from "../Upload";

class DocumentNotApproveModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            selectedFile: null,
            file: null,
            file_id:null
        }
        this.closeModal = this.closeModal.bind(this)
        //this.onChangeSelectedFile = this.onChangeSelectedFile.bind(this)
        //this.closeModal = this.closeModal.bind(this)
        this.onUploadComplete = this.onUploadComplete.bind(this)
        this.onUploadCancel = this.onUploadCancel.bind(this)
    }

    closeModal(modelId) {
        let { selectedFile } = this.state
        this.setState({
            selectedFile: ''
        })
            //this.props.closeModel(modelId)
        this.onUploadCancel(modelId)
    }
    onValidate = (file, file_type) => {
        const { upload_files } = this.props
        if (file == null) {
            msg.error('กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
            return false
        } else {
            let isDupplicateFile = false
            isDupplicateFile = upload_files && upload_files.some(f => f.file_name === file.name && f.file_category === file_type)
            if (isDupplicateFile) {
                msg.error('ไม่สามารถอัพโหลดไฟล์ชื่อเดียวกันได้')
                return false
            }
        }
        this.setState({
            selectedFile: file
        })
        return true
    }
    onChangeSelectedFile = (file, file_type) => {
        this.setState({
            selectedFile: file
        })

        this.props.onChangeSelectedFile(file, file_type) 

    }

    onUploadComplete = (modalId) => {     
        this.props.onUploadComplete(modalId)
        const modalElement = document.getElementById(modalId);

        if(modalElement)
        {
            window.$(modalElement).modal('hide');
        }
    }
    onUploadCancel = (modalId) => {     
        this.props.onUploadCancel(modalId)
        const modalElement = document.getElementById(modalId);

       if(modalElement)
        {
            window.$(modalElement).modal('hide');
        }
    }

    render() {
        console.log("DocumentModal.render()")
        let { selectedFile } = this.state
        return (
            <div>
                {/* <div className="modal fade sp-modal rrs-modal" id="attachedDocumentNormalModal" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentNormalModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentNormalModalLabel">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentNormalModal")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'N'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'N')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'N')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentNormalModal')}
                                    defaultFileName={'เอกสารแนบ'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade sp-modal rrs-modal" id="attachedDocumentPenaltyModal" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentPenaltyModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentPenaltyModalLabel">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentPenaltyModal")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'P'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'P')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'P')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentPenaltyModal')}
                                    defaultFileName={'เอกสารแนบ'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>
           */}
                <div className="modal fade sp-modal rrs-modal" id="attachedDocumentNotAppModal1" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentNotAppModal1Label" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentNotAppModal1Label">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentNotAppModal1")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'A1'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'A1')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'A1')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentNotAppModal1')}
                                    onUploadCancel={() => this.onUploadCancel('attachedDocumentNotAppModal1')}
                                    defaultFileName={'รายงานความเห็นแย้ง'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade sp-modal rrs-modal" id="attachedDocumentNotAppModal2" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentNotAppModal2Label" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentNotAppModal2Label">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentNotAppModal2")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'A2'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'A2')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'A2')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentNotAppModal2')}
                                    onUploadCancel={() => this.onUploadCancel('attachedDocumentNotAppModal2')}
                                    defaultFileName={'รายงานความเห็นแย้ง'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>
          
                <div className="modal fade sp-modal rrs-modal" id="attachedDocumentNotAppModal3" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentNotAppModal3Label" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentNotAppModal3Label">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentNotAppModal3")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'A3'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'A3')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'A3')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentNotAppModal3')}
                                    onUploadCancel={() => this.onUploadCancel('attachedDocumentNotAppModal3')}
                                    defaultFileName={'รายงานความเห็นแย้ง'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade sp-modal rrs-modal" id="attachedDocumentNotAppModal4" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentNotAppModal4Label" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentNotAppModal4Label">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentNotAppModal4")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'A4'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'A4')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'A4')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentNotAppModal4')}
                                    onUploadCancel={() => this.onUploadCancel('attachedDocumentNotAppModal4')}
                                    defaultFileName={'รายงานความเห็นแย้ง'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade sp-modal rrs-modal" id="attachedDocumentNotAppModal5" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentNotAppModal5Label" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentNotAppModal5Label">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentNotAppModal5")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'A5'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'A5')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'A5')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentNotAppModal5')}
                                    onUploadCancel={() => this.onUploadCancel('attachedDocumentNotAppModal5')}
                                    defaultFileName={'รายงานความเห็นแย้ง'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade sp-modal rrs-modal" id="attachedDocumentNotAppModal6" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentNotAppModal6Label" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentNotAppModal6Label">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentNotAppModal6")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'A6'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'A6')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'A6')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentNotAppModal6')}
                                    onUploadCancel={() => this.onUploadCancel('attachedDocumentNotAppModal6')}
                                    defaultFileName={'รายงานความเห็นแย้ง'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade sp-modal rrs-modal" id="attachedDocumentNotAppModal7" tabIndex={-1} role="dialog" aria-labelledby="attachedDocumentNotAppModal7Label" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedDocumentNotAppModal7Label">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedDocumentNotAppModal7")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'A7'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'A7')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'A7')}
                                    onUploadComplete={() => this.onUploadComplete('attachedDocumentNotAppModal7')}
                                    defaultFileName={'รายงานความเห็นแย้ง'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>
          


                <div className="modal fade sp-modal rrs-modal" id="attachedNotApprove0032Modal" tabIndex={-1} role="dialog" aria-labelledby="attachedNotApprove0032ModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedNotApprove0032ModalLabel">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedNotApprove0032Modal")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanel
                                    transaction_no={this.props.transaction_no}
                                    file_category={'NA'}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, 'NA')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, 'NA')}
                                    onUploadComplete={() => this.onUploadComplete('attachedNotApprove0032Modal')}
                                    onUploadCancel={() => this.onUploadCancel('attachedNotApprove0032Modal')}
                                    defaultFileName={'F-นจ.จบญ-0032'}
                                    selectedFile={selectedFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>
          
                <div className="modal fade sp-modal rrs-modal" id="attachedChangeCommitteeModal" tabIndex={-1} role="dialog" aria-labelledby="attachedChangeCommitteeModal" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="attachedChangeCommitteeModalLabel">Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal("attachedChangeCommitteeModal")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanelCommittee
                                    transaction_no={this.props.transaction_no}
                                    file_category={this.props.file_category ?? 'CM'}
                                    file_transaction_no = {this.props.dataId}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, this.props.file_category ?? 'CM')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, this.props.file_category ?? 'CM')}
                                    onUploadComplete={() => this.onUploadComplete('attachedChangeCommitteeModal')}
                                    onUploadCancel={() => this.onUploadCancel('attachedChangeCommitteeModal')}
                                    defaultFileName={this.props.defaultFileName ?? 'เอกสารเปลี่ยนแปลงคณะกรรมการตรวจรับ'}
                                    selectedFile={selectedFile}
                                /> 
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, UploadRedux } = state
    return {
        transaction: MainRedux.transaction,
        upload_files: UploadRedux.upload_files,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentNotApproveModal)